import { render, staticRenderFns } from "./EMLanguageSwitch.vue?vue&type=template&id=302d4318&"
import script from "./EMLanguageSwitch.vue?vue&type=script&lang=js&"
export * from "./EMLanguageSwitch.vue?vue&type=script&lang=js&"
import style0 from "./EMLanguageSwitch.vue?vue&type=style&index=0&id=302d4318&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
